import React, { ReactElement, useState } from 'react';
import { Text, Box, Button, VStack, HStack } from '@chakra-ui/react';
import { useWorksheetSession } from 'contexts/WorksheetSessionContext';
import { MultipleChoiceBlockProps } from '../MultipleChoiceBlock';
import { MCOption } from '../teacher/TeacherMCBlock';
import { MCSubmittedOption } from '../MCSubmittedOption';
import { StudentMCOption } from './StudentMCOption';

type Props = MultipleChoiceBlockProps;

export const StudentMCBlock = ({ block, editor }: Props): ReactElement => {
  const [shouldShowResults, setShouldShowResults] = useState(block.props.isSubmitted);
  const worksheetSession = useWorksheetSession();

  const options = JSON.parse(block.props.options) as MCOption[];

  const toggleOption = (index: number): void => {
    const updated = options.map((opt, i) =>
      i === index ? { ...opt, isChecked: !opt.isChecked } : opt
    );
    editor.updateBlock(block, {
      props: {
        options: JSON.stringify(updated),
      },
    });
  };

  const submitAndValidate = (): void => {
    editor.updateBlock(block, {
      props: {
        isSubmitted: true,
      },
    });

    setShouldShowResults(true);
    if (worksheetSession?.onBlockSubmit) {
      worksheetSession.onBlockSubmit(editor.document);
    }
  };

  const handleReset = (): void => {
    options.forEach((opt) => {
      opt.isChecked = false;
    });
    editor.updateBlock(block, {
      props: {
        options: JSON.stringify(options),
      },
    });
  };

  return (
    <VStack
      border="default"
      borderColor="border.accent"
      borderRadius="l"
      py="l"
      gap="l"
      width="100%"
      alignItems="flex-start"
      contentEditable={false}
      bg="grey.white"
    >
      <Box px="l" width="100%">
        <Text textStyle="h4.medium" color="text.primary" whiteSpace="pre-line">
          {block.props.question}
        </Text>
      </Box>
      <VStack gap="10px" width="100%" alignItems="flex-start">
        <VStack gap="0" width="100%">
          {options.map((opt, i) =>
            shouldShowResults ? (
              <MCSubmittedOption
                // eslint-disable-next-line react/no-array-index-key
                key={i}
                opt={opt}
                i={i}
              />
            ) : (
              <StudentMCOption
                // eslint-disable-next-line react/no-array-index-key
                key={i}
                opt={opt}
                i={i}
                toggleOption={toggleOption}
              />
            )
          )}
        </VStack>
        <Box px="l" width="100%">
          {!shouldShowResults ? (
            <HStack gap="15px">
              <Button type="submit" variant="primary" onClick={submitAndValidate}>
                Abschicken
              </Button>
              <Button
                type="reset"
                variant="tertiary"
                color="text.primary"
                onClick={handleReset}
              >
                Zurücksetzen
              </Button>
            </HStack>
          ) : (
            <Text textStyle="body.m.regular" color="text.quaternary">
              Antwort gespeichert!
            </Text>
          )}
        </Box>
      </VStack>
    </VStack>
  );
};
